const baseUrl = "https://dynamodb."

const zoneExtension = (zone: string) => {
  return zone.startsWith("cn-") ? ".cn" : ""
}

export const zoneEndpoint = (zone: string): string => {
  return `${baseUrl + zone}.amazonaws.com${zoneExtension(zone)}/`
}
